import React from 'react';
import { connect } from 'react-redux';
import ShowtimesBlock from './ShowtimesBlock';
import { ShowtimesBlockProps } from './ShowtimesBlock';
import { authShowLogin } from '../../../actions/creators';

interface Props extends ShowtimesBlockProps {
    isUserLogged: boolean;
    onFavesSelectorOpen: () => void;
}

const FavoriteCinemasShowtimesBlock = (props: Props) => {
    return <ShowtimesBlock
        {...props}
        title="Mis cines"
        subtitle={props.isUserLogged ? <a href="#" onClick={e => { e.preventDefault(); props.onFavesSelectorOpen(); }}>Agregar cine favorito</a> : null}
        emptyMessage="Esta película no está disponible entre tus cines favoritos. Abajo podrás ver en qué cines te esperamos para verla 😉"
        Content={Content}
    />;
};

const Content = (props: Props) => {
    if (!props.isUserLogged) {
        return <ConnectedNotLoggedContent />;
    }
     
    if (!props.favCinemasIds || !props.favCinemasIds.length) {
        return <div className="my-3">
            Aún no tienes cines favoritos. Haz click en el corazón al costado del nombre de los cines para que aparezcan en esta sección.
        </div>;
    }

    return null;
};

const NotLoggedContent = (props: { openLogin: () => void }) => {
    const onLoginClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        props.openLogin();
    };

    return <div className="my-3">
        <a href="/login" onClick={onLoginClick}>Inicia sesión</a> para guardar tus cines y ver sus horarios rápidamente.
    </div>;
};

const mapDispatchToProps = dispatch => ({
    openLogin: () => dispatch(authShowLogin()),
});

const ConnectedNotLoggedContent = connect(
    null,
    mapDispatchToProps
)(NotLoggedContent);

export default FavoriteCinemasShowtimesBlock;